import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import ProfileIcon from "@icons/myicons/user-1.svg?react";
import NotificationsIcon from "@icons/myicons/email-letter-mail-notification.svg?react";
import CurrencyIcon from "@icons/myicons/cash.svg?react";
import AdvancedIcon from "@icons/myicons/tools.svg?react";
import StarIcon from "@icons/myicons/star.svg?react";
import ShieldIcon from "@icons/myicons/insurance.svg?react";
import KeyIcon from "@icons/myicons/key.svg?react";
import { SettingsMenuItem } from "@features/settings/components/SettingsSidebar/SettingsMenuItem";
import { useFeatureFlag } from "@hooks";
import { MandatorConditional } from "@helpers";

export const SettingsMenu = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const premiumEnabled = useFeatureFlag("PREMIUM");
  const apiTokensEnabled = useFeatureFlag("API_TOKENS");

  return (
    <Box>
      <Typography
        variant="overline"
        color="textSecondary"
        textTransform="uppercase"
        mb={1.5}
        ml={2}
      >
        {t("settings.sidebar.common.title")}
      </Typography>
      <Box display="flex" flexDirection="column" gap={0.5}>
        <SettingsMenuItem
          to="/settings/profile"
          title={t("settings.sidebar.common.profile")}
          icon={<ProfileIcon fontSize="small" />}
          active={pathname === "/settings/profile"}
        />
        <SettingsMenuItem
          to="/settings/notifications"
          title={t("settings.sidebar.common.notifications")}
          icon={<NotificationsIcon fontSize="small" />}
          active={pathname === "/settings/notifications"}
        />
        <SettingsMenuItem
          to="/settings/currency"
          title={t("settings.sidebar.common.currency")}
          icon={<CurrencyIcon fontSize="small" width="20px" />}
          active={pathname === "/settings/currency"}
        />
        <MandatorConditional hideFor={["kpmg-germany"]}>
          {premiumEnabled && (
            <SettingsMenuItem
              to={`${import.meta.env.VITE_APP_ROOT_URL}/angebote-finanzmanager`}
              title={t("settings.sidebar.common.premium")}
              icon={<StarIcon fontSize="small" />}
              active={false}
            />
          )}
        </MandatorConditional>
        <SettingsMenuItem
          to="/settings/advanced"
          title={t("settings.sidebar.common.advanced")}
          icon={<AdvancedIcon fontSize="small" />}
          active={pathname === "/settings/advanced"}
        />
        <MandatorConditional hideFor={["kpmg-germany"]}>
          <SettingsMenuItem
            to="/settings/two-factor-authentication"
            title={t("settings.sidebar.twoFA.title")}
            icon={<ShieldIcon fontSize="small" height={18} width={18} />}
            active={pathname === "/settings/two-factor-authentication"}
          />
        </MandatorConditional>
        {apiTokensEnabled && (
          <SettingsMenuItem
            to="/settings/api-access"
            title={t("settings.sidebar.common.apiAccess")}
            icon={<KeyIcon fontSize="small" height={18} width={18} />}
            active={pathname === "/settings/api-access"}
          />
        )}
      </Box>
    </Box>
  );
};
